'use client';

import { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import styles from './TextSlider.module.scss';

interface TextSliderClientProps {
	sliderText: string[];
}

export function TextSliderClient({ sliderText }: TextSliderClientProps) {
	const [activeSlide, setActiveSlide] = useState(0);

	const settings = {
		infinite: true,
		speed: 1500,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
	};

	const handleSetActiveSlide = (index: number) => {
		setActiveSlide(index);
	};

	return (
		<section className={styles.textSliderSection}>
			<div className="container container--max">
				{sliderText.length > 0 ? (
					<div className={styles.textSlider} data-aos="fade-up">
						<div className={styles.sliderTrack}>
							<Slider afterChange={handleSetActiveSlide} {...settings}>
								{sliderText.map((text, idx) => (
									<div key={`${text}-${idx}`}>
										<p aria-hidden={activeSlide === idx ? false : true}>
											{text}
										</p>
									</div>
								))}
							</Slider>
						</div>
					</div>
				) : (
					<></>
				)}
			</div>
		</section>
	);
}
